/* eslint-disable @typescript-eslint/no-explicit-any */
import { toast, ToastContent, ToastOptions } from 'react-toastify';

export const toastError = (content: ToastContent, options?: ToastOptions): any => {
  options && delete options.type;
  return toast(content, {
    type: 'error',
    ...options,
  });
};

export const toastInfo = (content: ToastContent, options?: ToastOptions): any => {
  options && delete options.type;
  return toast(content, {
    type: 'info',
    ...options,
  });
};

export const toastSuccess = (content: ToastContent, options?: ToastOptions): any => {
  options && delete options.type;
  return toast(content, {
    type: 'success',
    ...options,
  });
};

export const toastWarning = (content: ToastContent, options?: ToastOptions): any => {
  options && delete options.type;
  return toast(content, {
    type: 'warning',
    ...options,
  });
};
